import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'app/store';

const selectPlanState = (state: RootState) => state.plan;

export const selectPlanEntitlements = createSelector(
  [selectPlanState],
  (planState) => planState.entitlements ?? {},
);

export const selectIsPlanDetailsExist = createSelector(
  [selectPlanEntitlements],
  (entitlements) => Object.keys(entitlements).length > 0,
);
